import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Seo from "@/components/Seo";
import { FadeUp } from "@/components/Reveal";
import { QuoteButton } from "@/components/Layout";
import { SERVICES } from "@/content/siteContent";

export default function Services() {
  return (
    <>
      <Seo
        title="Moving & Hauling Services | Home Team Moving Co."
        siteName="Home Team Moving Co."
        description="Residential moving, packing, junk removal, estate & commercial cleanouts, donation & appliance delivery, post-move cleanup and property turnover across Southern California."
      />
      <section className="border-b border-white/10">
        <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:py-24">
          <FadeUp>
            <p className="eyebrow mb-4">Full-Service Catalog</p>
            <h1 className="max-w-3xl font-display text-4xl font-extrabold uppercase leading-none tracking-tight text-white sm:text-5xl lg:text-6xl">
              Every job. <span className="text-gold">One crew.</span>
            </h1>
            <p className="mt-5 max-w-2xl leading-relaxed text-slate-300">
              Thirteen specialized services, one veteran-led team. Every price below is a starting point — your exact, written quote is always free before we roll.
            </p>
          </FadeUp>
        </div>
      </section>
      <section>
        <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:py-20">
          <div data-testid="services-grid" className="grid gap-px border border-white/10 bg-white/10 sm:grid-cols-2 lg:grid-cols-3">
            {SERVICES.map((s, i) => (
              <FadeUp key={s.id} delay={(i % 3) * 0.08} className="group flex flex-col bg-navy-950 p-8 transition-colors duration-300 hover:bg-navy-800">
                <div className="flex items-baseline justify-between">
                  <p className="text-outline font-display text-4xl font-extrabold leading-none">{String(i + 1).padStart(2, "0")}</p>
                  <p className="text-[10px] font-semibold uppercase tracking-[0.25em] text-gold/70">{s.category}</p>
                </div>
                <h2 className="mt-6 font-display text-xl font-bold uppercase tracking-wide text-white">{s.title}</h2>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-slate-400">{s.description}</p>
                <p data-testid={`service-price-${s.id}`} className="mt-5 flex items-baseline gap-2">
                  <span className="font-display text-2xl font-extrabold uppercase tracking-wide text-gold">{s.price}</span>
                  <span className="text-[10px] uppercase tracking-[0.2em] text-slate-500">· exact price via free quote</span>
                </p>
                <Link
                  to={`/quote?service=${s.id}`}
                  data-testid={`service-quote-link-${s.id}`}
                  className="mt-6 inline-flex items-center gap-2 font-display text-xs font-bold uppercase tracking-[0.25em] text-gold transition-colors hover:text-gold-light"
                >
                  Request this service <ArrowRight className="h-3.5 w-3.5 transition-transform duration-300 group-hover:translate-x-1" />
                </Link>
              </FadeUp>
            ))}
          </div>
          <FadeUp className="mt-16 flex flex-col items-center gap-5 border border-gold/30 bg-navy-900/60 px-6 py-12 text-center">
            <h2 className="font-display text-2xl font-bold uppercase tracking-tight text-white sm:text-3xl">
              Not sure which service fits?
            </h2>
            <p className="max-w-xl text-sm text-slate-300">
              Snap a few photos of the job and send them over — we'll figure out the rest and come back with a straight answer.
            </p>
            <QuoteButton testId="services-quote-cta" className="px-9 py-4 text-base" />
          </FadeUp>
        </div>
      </section>
    </>
  );
}
